import { Stack } from "@mantine/core"
import { useDisclosure } from "@mantine/hooks"
import { Button } from "@tfg/ui"

import { OrganizationsResponses } from "@tfg/types/endpoints/organizations"

import { CreateOrUpdateDisplaySettingsModal } from "~/pages/Brand/OrganizationSettings/ProductPages/DisplaySettingsCrud/CreateOrUpdateDisplaySettingsModal.tsx"

interface Props {
  organizationSettingsId: number
  organizationId: number
  displaySetting: OrganizationsResponses.Organization["settings"]["displaySettings"][number]
}

export const UpdateDisplaySettingButton = ({
  organizationSettingsId,
  organizationId,
  displaySetting,
}: Props) => {
  const [opened, { open, close }] = useDisclosure()

  return (
    <Stack>
      <Button variant="admin" onClick={() => open()}>
        Update
      </Button>
      <CreateOrUpdateDisplaySettingsModal
        opened={opened}
        close={close}
        organizationSettingsId={organizationSettingsId}
        organizationId={organizationId}
        displaySetting={displaySetting}
      />
    </Stack>
  )
}
